<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
    :top="top"
    :bottom="bottom"
    :right="right"
    :left="left"
    :multi-line="multiLine"
    :vertical="vertical"
    @input="closeSnackbar"
  >
    {{ message }}
    <template #actions>
      <v-btn
        color="light-blue-darken-2"
        variant="text"
        @click="closeSnackbar"
      >
        {{ closeLabel }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('snackbar', [
      'timeout',
      'top',
      'bottom',
      'right',
      'left',
      'multiLine',
      'vertical',
      'snackbar',
      'message',
      'closeLabel'
    ])
  },
  methods: {
    ...mapActions('snackbar', ['closeSnackbar'])
  }
}
</script>
